import { useMemo, useCallback } from 'react';
import { prop } from 'ramda';
import { useDispatch } from 'react-redux';
import { useGetPlayerInfo } from 'server';
import { useAppSelector } from 'js/store/hooks';
import { usePlayerFields } from 'js/hooks/usePlayerFields';

import * as actions from '../store/actions';
import { parseUserDetails } from '../helpers';

export const useFetchParams = () => {
    const { networkType, displayPlayer } = useAppSelector(prop('leaderboard')) || {};

    return useMemo(() => {
        const networkTypes = displayPlayer === 'nicknameByNetworkType' && networkType ? [networkType] : null;
        const networkDataFilters = networkTypes ? [1, 2, 3] : null;

        return { networkTypes, networkDataFilters };
    }, [networkType, displayPlayer]);
};

export const useFetchUserDetails = () => {
    const dispatch = useDispatch();
    const getPlayerInfo = useGetPlayerInfo();
    const { networkTypes, networkDataFilters } = useFetchParams();
    const defaultPlayerFields = usePlayerFields();

    return useCallback(async (playerFields = [], { signal } = {}) => {
        const fields = playerFields.length ? playerFields : defaultPlayerFields;
        const playerInfoData = await getPlayerInfo({
            returnContactPreferences: true,
            requestedPlayerData: fields,
            requestedNetworkTypes: networkTypes,
            playerNetworkDataFilters: networkDataFilters
        }, { signal });
        const userDetails = parseUserDetails(playerInfoData);

        dispatch(actions.setUserDetails({ userDetails, isForce: true }));

        return userDetails;
    }, [
        dispatch,
        defaultPlayerFields,
        getPlayerInfo,
        networkDataFilters,
        networkTypes
    ]);
};
